export const monthsOptions = () => {
  return Array.from(Array(12).keys()).map(month => {
    return {
      key: month + 1,
      text: `${month + 1} ${month >= 1 ? 'Meses' : 'Mês'}`,
      value: month + 1
    };
  });
};
